const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

/**
 * Staging CORS allows `https://localhost:8000`, not ngrok / LAN IPs.
 * Webpack *dev* proxies `/api` → API_URL, so off-localhost *dev* must call
 * same-origin `/api`. Production Docker has no that proxy — always use API_URL
 * (`https://react.generate.tax/api` on staging, etc.).
 */
export function resolveBrowserApiBaseUrl(raw: string | undefined): string {
  const url = raw || '';
  if (typeof window === 'undefined') return url;
  if (LOCAL_HOSTS.has(window.location.hostname)) return url;
  if (process.env.NODE_ENV === 'development') return '/api';
  return url;
}

